import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const StockContext = createContext({ map: {}, isSoldOut: () => false, refresh: () => {} });

export const useStock = () => useContext(StockContext);

export const StockProvider = ({ children }) => {
  const [map, setMap] = useState({});

  const refresh = () => {
    axios.get(`${API}/product-status`).then(({ data }) => setMap(data || {})).catch(() => {});
  };
  useEffect(() => { refresh(); }, []);

  // Backend value wins; otherwise fall back to the product's static flag.
  const isSoldOut = (p) => (p.id in map ? !!map[p.id].sold_out : !!p.soldOut);
  const quantityOf = (p) => (p.id in map ? map[p.id].quantity : null);

  return <StockContext.Provider value={{ map, isSoldOut, quantityOf, refresh }}>{children}</StockContext.Provider>;
};
